(function($) {
  const WD = new WebsiteData();

  var
  $form = $('#subscribe_form'),
  $result = $form.find('.form-result'),
  $recaptcha = $form.find('.g-recaptcha');

  $form.find('input').on('focus', () => CustomRenderRecaptcha());

  $form.on('submit', function(event) {
    event.preventDefault();
    event.stopPropagation();

    $result.empty().hide();

    if (this.checkValidity() === false) {
      this.classList.add('was-validated')
      return;
    }

    grecaptcha.execute( $recaptcha.attr('data-index') );
  });

  if (window.SubscribeFormSubmit === undefined) {
    window.SubscribeFormSubmit = function(token) {
      if (token === undefined) {
        alert('You need to verify recaptcha');
        return
      }

      $form.find('[type=submit]')
        .addClass('btn-loading')
        .prop('disabled', true)

      if (local.websiteDataAPI.api_subscribe) {
        // Send throught SMTP
        var wpmail = $.post({
          url: local.ajaxurl,
          data: new FormData($form.get(0)),
          processData: false,
          contentType: false,
        })

        wpmail.done(res => {
          if (res.success) {
            $form.removeClass('was-validated')
            $form.find('input, select, button').blur()
            $form.get(0).reset();
            $.magnificPopup.open({
              type: 'inline',
              items: {
                src: `<div class="popup-subscribe__content">
                ${res.data.message}
                <button class="mfp-close" onclick="jQuery.magnificPopup.instance.close()"><i class="fal fa-lg fa-times-circle"></i></button>
                </div>`
              },
              removalDelay: 500,
              mainClass: 'mfp-scale-up popup-subscribe',
              autoFocusLast: false,
            })
          } else {
            $result.html(`<span class="text-danger">${local.subscription.i18n["failed-message"]}</span>`);
            $result.show();
          }
        })

        wpmail.fail(() => {
          $result.html(`<span class="text-danger">${local.subscription.i18n["failed-message"]}</span>`);
          $result.show();
        })

        wpmail.always(() => {
          $form.find('[type=submit]')
            .removeClass('btn-loading')
            .prop('disabled', false)

          grecaptcha.reset( $recaptcha.attr('data-index') );
        })

        // Send through Travelanium Data API
        WD.post({
          formKey: local.websiteDataAPI.api_subscribe,
          email: $form.find('[name=subscribe_email]').val(),
          message: 'Subscribe from: ' + window.location.href
        }, {
          done() {
            console.log('done')
          },
          fail() {
            console.log('fail')
          }
        })
      }
    }
  }
})(jQuery);